import { extendTheme } from "@chakra-ui/react";

// * Include custom option in here, like colors, fonts and etc.
const customTheme = {};

const theme = extendTheme(customTheme);

export default theme;